enum WaybillTemplatePrintType {
    CAINIAO = "CAINIAO",

    JDL = "JDL",

    PDD = "PDD",

    KWAISHOP = "KWAISHOP",

    /**
     * 蓝牙打印
     *
     * @deprecated 小程序端即将下线
     */
    PRINT_CMD = "PRINT_CMD",

    JINRITEMAI = "JINRITEMAI",

    SF = "SF",

    CHANNEL_SHOP = "CHANNEL_SHOP",

    XIAOHONGSHU = "XIAOHONGSHU",

    AIKUCUN = "AIKUCUN",
}

export default WaybillTemplatePrintType;
